module.exports = __webpack_public_path__ + "img/decor-center.505c86be.png";